import React from "react";
import { styled } from "styled-components";

const SidebarBoxGrey = styled.div`
    padding: 20px;
    border-radius: 5px;
    & h6 {
        margin: 0 0 15px;
        color: #2a5934;
        font-family: "Roboto Slab", serif;
        font-weight: 700;
        text-transform: uppercase;
        font-size: 1.3rem;
    }
    & p {
        margin: 0;
        font-family: "Poppins", sans-serif;
        font-weight: 400;
    }
    & .sidebar-link {
        color: #2a5934;
        text-decoration: underline;
        cursor: pointer;
    }
    & .sidebar-button {
        cursor: pointer;
        background-color: #2a5934;
        color: #fff;
        display: inline-block;
        margin: 15px 0 0;
        padding: 10px 20px;
        border: 1px solid #222;
        border-radius: 5px;
        text-decoration: none;
        text-transform: uppercase;
        font-family: "Poppins", sans-serif;
        font-weight: 400;
    }
`;

export const Volunteering = () => {

    return (
        <SidebarBoxGrey>
            <h6>Volunteering</h6> 
            <p>Would you be interested in getting involved with helping to look after the wood?</p>
            <p><a className="sidebar-link" href="/static/volunteering">Click here to find out more.</a></p>    

        </SidebarBoxGrey>
    )
}

export default Volunteering;
